const Header = () => {
    return (
        <>
        <div className="Header">
        <h1>
          Owen Manby: Portfolio
        </h1>
        <h2>
          Junior Software Developer, He/Him, passionate about learning, just started my first role.
        </h2>
        </div>
        </>
    )
}

export default Header;